import React, { useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import JsBarcode from "jsbarcode";
import "./BarcodePrint.css"
import { Box, Button, Paper, Card, CardContent, Typography } from '@mui/material';

const LandDocBarcode = () => {
  const barcodeRef = useRef();
  const [searchParams] = useSearchParams();
  const parcelCode = searchParams.get("parcelCode");
  const oldParcel = searchParams.get("oldParcel");
  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, parcelCode, {
        format: "CODE128",
        width: 2.8,
        height: 70,
        displayValue: true,
        fontSize: 30,
      });
    }
  }, [parcelCode]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box className='otherSide' id="otherSide">
      <Box className='surveyLayouts' id="surveyLayouts"></Box>
      <Box p={4} textAlign="center">
        {/* พื้นที่ทั้งหมด */}
        <Box id="print-area" className="print-area">
          <Paper
            elevation={3}
            sx={{
              width: 400,
              mx: 'auto',
              backgroundColor: 'white',
            }}
          >
            <Box ref={barcodeRef} component="svg" />
            <Typography
              sx={{ fontSize: 30, }}
            >
              {oldParcel}
            </Typography>
          </Paper>
        </Box>

        {/* ปุ่มพิมพ์ (จะซ่อนตอนสั่งพิมพ์) */}
        <Button
          variant="contained"
          color="secondary"
          onClick={handlePrint}
          sx={{ mt: 4 }}
          className="print-hidden"
        >
          🖨️ พิมพ์เฉพาะฉลาก
        </Button>
      </Box>
    </Box>
  );
};

export default LandDocBarcode;
